import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useTranslation } from "react-i18next";

const MatchDialog = ({ open, threadId, attendee, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const name = attendee?.firstName || "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: "24px" } }}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          px: 3,
          pt: 4,
          pb: 3,
        }}
      >
        <Box sx={{ position: "relative", mb: 2 }}>
          <Avatar
            src={attendee?.profileImage || undefined}
            sx={{ width: 88, height: 88 }}
          >
            {name.charAt(0)}
          </Avatar>
          <Box
            sx={{
              position: "absolute",
              right: -6,
              bottom: -6,
              width: 34,
              height: 34,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: "#68C371",
              border: "3px solid #fff",
            }}
          >
            <FavoriteIcon sx={{ fontSize: 16, color: "#fff" }} />
          </Box>
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          {t("chat.match.title")}
        </Typography>
        <Typography sx={{ fontSize: 14, color: "text.secondary", mb: 3 }}>
          {t("chat.match.body", { name })}
        </Typography>
        <Button
          className="tnfm-pill-btn"
          variant="contained"
          fullWidth
          sx={{ mb: 1 }}
          onClick={() => navigate(`/chats/${threadId}`)}
        >
          {t("chat.match.open")}
        </Button>
        <Button className="tnfm-pill-btn" fullWidth onClick={onClose}>
          {t("chat.match.later")}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default MatchDialog;
